import { GradeMaterials } from 'src/app/shared/models/grade-materials.model';

export const GRADES_9_10_MATERIALS: GradeMaterials = {
  categories: [
    {
      headingEn: 'Introductory items',
      headingEs: 'Elementos introductorios',
      items: [
        {
          id: 'program-guide-9-10',
          labelEn: 'Program Guide 9—10',
          labelEs: 'Guía del programa 9—10',
          subLabelEn: 'website\'s program section',
          subLabelEs: 'sección del programa de la página de web',
          filePath: 'assets/printables/en/9-10/Program_Guide_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Program_Guide_9-10_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'letter-parents-9-10',
          labelEn: 'Letter to parents',
          labelEs: 'Carta para los padres',
          filePath: 'assets/printables/en/9-10/Letter_Parents_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Letter_Parents_9-10_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'letter-administrator-9-10',
          labelEn: 'Letter to administrator',
          labelEs: 'Carta para los administradores',
          filePath: 'assets/printables/en/9-10/Letter_Administrator_9-10.docx',
          filePathEs: 'assets/printables/es/9-10/Letter_Administrator_9-10_ES.docx',
          iconType: 'doc'
        },
        {
          id: 'letter-donation-9-10',
          labelEn: 'Donation request letter',
          labelEs: 'Carta de solicitud para donaciones',
          filePath: 'assets/printables/en/9-10/Letter_Donation_Request_9-10.docx',
          filePathEs: 'assets/printables/es/9-10/Letter_Donation_Request_9-10_ES.docx',
          iconType: 'doc'
        }
      ]
    },
    {
      headingEn: 'Employment',
      headingEs: 'Empleo',
      items: [
        {
          id: 'payday-video-9-10',
          labelEn: 'Payday video',
          labelEs: 'Video sobre el día de pago',
          filePath: 'assets/video/CE_S01.mp4',
          filePathEs: 'assets/video/CE_S01.mp4',
          iconType: 'video'
        },
        {
          id: 'job-application-9-10',
          labelEn: 'Job application',
          labelEs: 'Aplicación de trabajo',
          filePath: 'assets/printables/en/9-10/Job_Application_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Job_Application_9-10_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'job-offer-9-10',
          labelEn: 'Job offer',
          labelEs: 'Oferta de trabajo',
          filePath: 'assets/printables/en/9-10/Job_Offer_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Job_Offer_9-10_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'job-posters-9-10',
          labelEn: 'Job posters',
          labelEs: 'Afiches de trabajo',
          filePath: 'assets/printables/en/9-10/Job_Posters_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Job_Posters_9-10_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'paycheck-9-10',
          labelEn: 'Paychecks',
          labelEs: 'Sueldo',
          filePath: 'assets/printables/en/9-10/Paycheck_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Paycheck_9-10_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'business-license-9-10',
          labelEn: 'Business license',
          labelEs: 'Licencia de negocios',
          filePath: 'assets/printables/en/9-10/Business_License_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Business_License_9-10_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Banking',
      headingEs: 'Bancario/a',
      items: [
        {
          id: 'bank-slip-9-10',
          labelEn: 'Bank slips',
          labelEs: 'Recibos bancarios',
          filePath: 'assets/printables/en/9-10/Bank_Slip_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Bank_Slip_9-10_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'bank-log-9-10',
          labelEn: 'Classroom bank log',
          labelEs: 'El registro de banco para la clase',
          filePath: 'assets/printables/en/9-10/Bank_Log_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Bank_Log_9-10_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Fines',
      headingEs: 'Multas',
      items: [
        {
          id: 'fine-ticket-9-10',
          labelEn: 'Fine tickets',
          labelEs: 'Tiquetes de multa',
          filePath: 'assets/printables/en/9-10/Fine_Ticket_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Fine_Ticket_9-10_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'offense-log-9-10',
          labelEn: 'Offense log',
          labelEs: 'Registro de ofensas',
          filePath: 'assets/printables/en/9-10/Offense_Log_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Offense_Log_9-10_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Cash',
      headingEs: 'Dinero',
      items: [
        {
          id: 'bills-50-9-10',
          labelEn: '$50 bills',
          labelEs: 'Billetes de $50',
          subLabelEn: 'small bills: see grades 2—3',
          subLabelEs: 'facturas pequeñas: refiera los grados 2-3',
          filePath: 'assets/printables/en/9-10/Bills_50_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Bills_50_9-10_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'bills-100-9-10',
          labelEn: '$100 bills',
          labelEs: 'Billetes de $100',
          filePath: 'assets/printables/en/9-10/Bills_100_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Bills_100_9-10_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'bills-500-9-10',
          labelEn: '$500 bills',
          labelEs: 'Billetes de $500',
          filePath: 'assets/printables/en/9-10/Bills_500_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Bills_500_9-10_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Rent & deeds',
      headingEs: 'Alquiler y título de propiedad',
      items: [
        {
          id: 'rental-agreement-9-10',
          labelEn: 'Rental agreement',
          labelEs: 'Contrato de alquiler',
          filePath: 'assets/printables/en/9-10/Rental_Agreement_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Rental_Agreement_9-10_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'rent-log-9-10',
          labelEn: 'Rent log',
          labelEs: 'Registro de alquiler',
          filePath: 'assets/printables/en/9-10/Rent_Log_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Rent_Log_9-10_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'unpaid-rent-notice-9-10',
          labelEn: 'Unpaid rent notice',
          labelEs: 'Aviso de renta no pagada',
          filePath: 'assets/printables/en/9-10/Unpaid_Rent_Notice_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Unpaid_Rent_Notice_9-10_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'desk-deed-9-10',
          labelEn: 'Deed to desk',
          labelEs: 'Título de propiedad del escritorio',
          filePath: 'assets/printables/en/9-10/Desk_Deed_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Desk_Deed_9-10_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Bills & taxes',
      headingEs: 'Cuentas e impuestos',
      items: [
        {
          id: 'bill-pay-log-9-10',
          labelEn: 'Classroom bill pay log',
          labelEs: 'Registro de cuentas pagadas de la clase',
          filePath: 'assets/printables/en/9-10/Bill_Pay_Log_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Bill_Pay_Log_9-10_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'energy-log-9-10',
          labelEn: 'Classroom energy log',
          labelEs: 'Registro de energía de la clase',
          filePath: 'assets/printables/en/9-10/Energy_Log_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Energy_Log_9-10_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'tax-record-9-10',
          labelEn: 'Tax record form',
          labelEs: 'Documento de registro de impuestos',
          filePath: 'assets/printables/en/9-10/Tax_Record_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Tax_Record_9-10_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Auctions',
      headingEs: 'Subastas',
      items: [
        {
          id: 'auction-video-9-10',
          labelEn: 'Auction video',
          labelEs: 'Video sobre subastas',
          filePath: 'assets/video/CE_S04.mp4',
          filePathEs: 'assets/video/CE_S04.mp4',
          iconType: 'video'
        },
        {
          id: 'auction-record-9-10',
          labelEn: 'Auction record form',
          labelEs: 'Forma de registro de subasta',
          filePath: 'assets/printables/en/9-10/Auction_Record_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Auction_Record_9-10_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'auction-paddle-9-10',
          labelEn: 'Auction paddle',
          labelEs: 'Paleta de subastas',
          filePath: 'assets/printables/en/9-10/Auction_Paddle_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Auction_Paddle_9-10_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Year-end certificates',
      headingEs: 'Certificados de fin de año',
      items: [
        {
          id: 'saver-certs-9-10',
          labelEn: 'Saver certificates (Includes Saver, Super, and Ultimate awards)',
          labelEs: 'Certificado de ahorro (Incluye los premios Saver, Super y Ultimate)',
          filePath: 'assets/printables/en/9-10/Saver_Certs_9-10.pdf',
          filePathEs: 'assets/printables/es/9-10/Saver_Certs_9-10_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Posters & handouts',
      headingEs: 'Afiches y folletos',
      items: [
        {
          id: 'bonus-list-9-10',
          labelEn: 'Bonus list',
          labelEs: 'Lista de bonificaciones',
          filePath: 'assets/printables/en/9-10/Bonus_List_9-10.docx',
          filePathEs: 'assets/printables/es/9-10/Bonus_List_9-10_ES.doc',
          iconType: 'doc'
        },
        {
          id: 'fine-list-9-10',
          labelEn: 'Fine list',
          labelEs: 'Lista de multas',
          filePath: 'assets/printables/en/9-10/Fine_List_9-10.docx',
          filePathEs: 'assets/printables/es/9-10/Fine_List_9-10_ES.doc',
          iconType: 'doc'
        }
      ]
    }
  ],
  supplies: {
    headingEn: 'Supplies to have on hand',
    headingEs: 'Suministros para tener al alcance',
    items: [
      { labelEn: 'Envelopes', labelEs: 'Sobres' },
      { labelEn: 'Portfolio folders', labelEs: 'Carpetas de portafolios' },
      { labelEn: 'Cash drawer or box', labelEs: 'Caja de dinero' },
      { labelEn: 'Popsicle sticks for auction paddles', labelEs: 'Palos de paleta para las paletas de subasta' },
      { labelEn: 'Sticky notes', labelEs: 'Notas adhesivas' },
      { labelEn: 'Clipboard', labelEs: 'Portapapeles' },
      { labelEn: 'Auction items', labelEs: 'Artículos de subasta' }
    ]
  }
};
